import { BOTS_LIST } from '@/constants'
import type { Player } from '@acepoker/contract/acepoker'

export function getBotData(player: Player) {
  return player
    ? BOTS_LIST.find((el) => el.type.toLowerCase() === player.type?.toLowerCase())
    : null
}
